import { FileSignature } from 'lucide-react';
import { DataTable } from '@/components/DataTable';
import { StatusBadge } from '@/components/StatusBadge';
import { useApi } from '@/hooks/useApi';

interface ESignDoc {
  id: string;
  doc_type: string;
  title: string;
  signer_name: string;
  signer_email: string;
  status: string;
  sent_at?: string;
  signed_at?: string;
  expires_at?: string;
}

export function ESignPage() {
  const { data, loading } = useApi<{ documents: ESignDoc[] }>('esign');

  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold text-foreground flex items-center gap-2">
        <FileSignature className="w-5 h-5 text-amber-500" /> E-Signature Documents
      </h2>
      {loading ? <div className="text-muted-foreground">Loading...</div> : (
        <DataTable
          columns={[
            { key: 'title', header: 'Document', render: (r: ESignDoc) => <span className="font-medium">{r.title}</span> },
            { key: 'doc_type', header: 'Type', render: (r: ESignDoc) => <span className="capitalize text-xs">{r.doc_type.replace(/_/g, ' ')}</span> },
            { key: 'signer_name', header: 'Signer' },
            { key: 'signer_email', header: 'Email' },
            { key: 'sent_at', header: 'Sent', render: (r: ESignDoc) => r.sent_at?.split('T')[0] ?? '-' },
            { key: 'signed_at', header: 'Signed', render: (r: ESignDoc) => r.signed_at?.split('T')[0] ?? '-' },
            { key: 'status', header: 'Status', render: (r: ESignDoc) => <StatusBadge status={r.status} /> },
          ]}
          data={data?.documents ?? []}
          emptyMessage="No e-signature documents"
        />
      )}
    </div>
  );
}
